// extracted by mini-css-extract-plugin
export var chevron = "_gd-2";
export var dropdownItems = "_gd-0";
export var item = "_gd-1";